import axios, { InternalAxiosRequestConfig } from 'axios';
import { getScopeMap, graphConfig } from 'auth-config';
import { getAccessToken } from './api';

export const graphAxiosInstance = axios.create({
    baseURL: graphConfig.BASE_URL,
});

graphAxiosInstance.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
        const scopes = getScopeMap().login.scopes;
        const accessToken = await getAccessToken({ scopes });

        config.headers.Authorization = `Bearer ${accessToken}`;
        config.headers.Accept = 'application/json';
        config.headers['Content-Type'] = 'application/json';     

        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

// Function to call the Microsoft Graph /me endpoint using the configured Axios instance
export async function getGraphMe() {
    // Use the endpoint from your graphConfig or hardcode '/me' if appropriate
    const endpoint = graphConfig.graphMeEndpoint || '/me';
    const response = await graphAxiosInstance.get(endpoint);
    return response.data;
}


export default getGraphMe;
